// extracted by mini-css-extract-plugin
export var video = "ModalVideo-module--video--NpoSi";